export default "__VITE_PUBLIC_ASSET__55c30118__"